import { useState, useEffect, useCallback } from "react";

const N8N_POST = "https://n8n-fj1ps1uv3pf6pc4rctaol879.flowsister.site/webhook/54b8591a-4d2f-439b-9092-2ecc29724d54";
const N8N_GET  = "https://n8n-fj1ps1uv3pf6pc4rctaol879.flowsister.site/webhook/c051c0f0-562b-4527-816e-34eda6879f1a";
const N8N_RATE = "https://api.exchangerate-api.com/v4/latest/UAH";

const PARTNERS = [
  { id: 1, name: "Мама",   emoji: "👩", color: "#F2A65A" },
  { id: 2, name: "Леруся", emoji: "👧", color: "#7EC8C8" },
  { id: 3, name: "Влад",   emoji: "👦", color: "#B5A8D5" },
];

const CATS = [
  { icon: "🌐", label: "Домен" },
  { icon: "🛍️", label: "Shopify" },
  { icon: "🔌", label: "Додатки" },
  { icon: "📦", label: "Товари" },
  { icon: "📣", label: "Реклама" },
  { icon: "🎨", label: "Дизайн" },
  { icon: "🤖", label: "Автоматизація" },
  { icon: "📚", label: "Навчання" },
  { icon: "💼", label: "Сервіси" },
  { icon: "📦", label: "Інше" },
];

const TRANSLITERATE = {
  "лайф": "Life", "шопіфай": "Shopify", "алієкспрес": "AliExpress",
  "зендроп": "Zendrop", "дсерс": "DSers", "канва": "Canva",
  "фейсбук": "Facebook", "інстаграм": "Instagram", "тікток": "TikTok",
  "гугл": "Google", "адс": "Ads", "пейпал": "PayPal",
};

function transliterate(text) {
  const lower = text.toLowerCase().trim();
  return TRANSLITERATE[lower] || text;
}

function calcSettlements(records) {
  const spent = {};
  PARTNERS.forEach(p => { spent[p.id] = 0; });
  records.forEach(r => {
    if (r["Тип"] === "Розрахунок") return;
    const pid = PARTNERS.find(p => p.name === r["Партнер"])?.id;
    if (pid) spent[pid] += Number(r["Сума"]) || 0;
  });

  // Враховуємо розрахунки
  records.forEach(r => {
    if (r["Тип"] !== "Розрахунок") return;
    const fromId = PARTNERS.find(p => p.name === r["Від"])?.id;
    const toId   = PARTNERS.find(p => p.name === r["Кому"])?.id;
    if (fromId) spent[fromId] += Number(r["Сума"]) || 0;
    if (toId)   spent[toId]   -= Number(r["Сума"]) || 0;
  });

  const total = records
    .filter(r => r["Тип"] !== "Розрахунок")
    .reduce((s, r) => s + (Number(r["Сума"]) || 0), 0);

  const share = total / 3;
  const balance = {};
  PARTNERS.forEach(p => { balance[p.id] = spent[p.id] - share; });

  const debts = [];
  const pos = PARTNERS.filter(p => balance[p.id] > 0.01).map(p => ({ id: p.id, val: balance[p.id] }));
  const neg = PARTNERS.filter(p => balance[p.id] < -0.01).map(p => ({ id: p.id, val: -balance[p.id] }));
  let i = 0, j = 0;
  while (i < pos.length && j < neg.length) {
    const amt = Math.min(pos[i].val, neg[j].val);
    debts.push({ from: neg[j].id, to: pos[i].id, amount: amt });
    pos[i].val -= amt; neg[j].val -= amt;
    if (pos[i].val < 0.01) i++;
    if (neg[j].val < 0.01) j++;
  }
  return { debts, spent, total };
}

export default function App() {
  const [records, setRecords]       = useState([]);
  const [loading, setLoading]       = useState(true);
  const [tab, setTab]               = useState("add");
  const [activePerson, setAP]       = useState(1);
  const [amount, setAmount]         = useState("");
  const [desc, setDesc]             = useState("");
  const [cat, setCat]               = useState(CATS[0]);
  const [currency, setCurrency]     = useState("UAH");
  const [usdRate, setUsdRate]       = useState(null);
  const [sending, setSending]       = useState(false);
  const [sent, setSent]             = useState(false);
  const [filter, setFilter]         = useState(0);
  const [catFilter, setCatFilter]   = useState(null);
  const [editId, setEditId]         = useState(null);
  const [editAmount, setEditAmount] = useState("");
  const [editDesc, setEditDesc]     = useState("");
  const [settling, setSettling]     = useState(false);
  const [settleConfirm, setSettleConfirm] = useState(false);

  const fetchRecords = useCallback(async () => {
    try {
      const r = await fetch(N8N_GET);
      const data = await r.json();
      setRecords(Array.isArray(data) ? data : []);
    } catch (_) {}
    setLoading(false);
  }, []);

  const fetchRate = useCallback(async () => {
    try {
      const r = await fetch(N8N_RATE);
      const data = await r.json();
      setUsdRate(data.rates?.USD || null);
    } catch (_) {}
  }, []);

  useEffect(() => {
    fetchRecords();
    fetchRate();
    const interval = setInterval(fetchRecords, 15000);
    return () => clearInterval(interval);
  }, [fetchRecords, fetchRate]);

  const person = PARTNERS.find(p => p.id === activePerson);
  const toUAH = (amount, cur) => cur === "USD" && usdRate ? amount / usdRate : amount;

  const add = async () => {
    const num = parseFloat(amount.replace(",", "."));
    if (!num || num <= 0 || !desc.trim()) return;
    const translDesc = transliterate(desc);
    const amountUAH = toUAH(num, currency);
    const entry = {
      id: Date.now(),
      type: "expense",
      person: person.name,
      personId: activePerson,
      amount: Math.round(amountUAH * 100) / 100,
      amountOrig: num,
      currency,
      description: translDesc,
      category: cat.icon + " " + cat.label,
      date: new Date().toLocaleDateString("uk-UA"),
      time: new Date().toLocaleTimeString("uk-UA", { hour: "2-digit", minute: "2-digit" }),
      share: Math.round((amountUAH / 3) * 100) / 100,
    };
    setSending(true);
    try {
      await fetch(N8N_POST, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(entry),
      });
      await fetchRecords();
    } catch (_) {}
    setSending(false); setSent(true);
    setTimeout(() => setSent(false), 2000);
    setAmount(""); setDesc("");
  };

  const saveEdit = async (record) => {
    const num = parseFloat(editAmount.replace(",", "."));
    if (!num || num <= 0 || !editDesc.trim()) return;
    const updated = {
      ...record,
      id: record.ID,
      type: "edit",
      originalId: record.ID,
      amount: num,
      person: record["Партнер"],
      description: transliterate(editDesc),
      category: record["Категорія"],
      date: record["Дата"],
      editedAt: new Date().toLocaleString("uk-UA"),
      edited: true,
    };
    try {
      await fetch(N8N_POST, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updated),
      });
      await fetchRecords();
    } catch (_) {}
    setEditId(null);
  };

  // Розрахунок — записуємо всі борги як окремі записи
  const handleSettle = async () => {
    setSettling(true);
    try {
      for (const debt of debts) {
        const from = PARTNERS.find(p => p.id === debt.from);
        const to   = PARTNERS.find(p => p.id === debt.to);
        const entry = {
          id: Date.now() + Math.random(),
          type: "settle",
          person: from.name,
          від: from.name,
          кому: to.name,
          amount: Math.round(debt.amount * 100) / 100,
          description: `${from.name} → ${to.name} (розрахунок)`,
          category: "✅ Розрахунок",
          date: new Date().toLocaleDateString("uk-UA"),
          time: new Date().toLocaleTimeString("uk-UA", { hour: "2-digit", minute: "2-digit" }),
        };
        await fetch(N8N_POST, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(entry),
        });
      }
      await fetchRecords();
    } catch (_) {}
    setSettling(false);
    setSettleConfirm(false);
  };

  const { debts, spent, total } = calcSettlements(records);
  const totalUSD = usdRate ? (total * usdRate).toFixed(2) : null;
  const spentFor = (pid) => spent[pid] || 0;

  const filtered = records.filter(r => {
    if (filter !== 0 && r["Партнер"] !== PARTNERS.find(p => p.id === filter)?.name) return false;
    if (catFilter && !r["Категорія"]?.includes(catFilter)) return false;
    return true;
  });

  const catStats = CATS.map(c => ({
    ...c,
    total: records
      .filter(r => r["Категорія"]?.includes(c.label))
      .reduce((s, r) => s + (Number(r["Сума"]) || 0), 0),
  })).filter(c => c.total > 0);

  return (
    <div style={{
      position: "fixed", inset: 0, overflow: "hidden",
      background: "#0a0a0f", color: "#f0ece4",
      fontFamily: "'DM Sans', system-ui, sans-serif",
      display: "flex", flexDirection: "column",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Cormorant+Garamond:wght@600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; -webkit-tap-highlight-color: transparent; }
        input { font-family: inherit; }
        input::placeholder { color: rgba(240,236,228,0.25); }
        input:focus { outline: none; }
        .g { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.07); border-radius: 14px; }
        .btn { border: none; cursor: pointer; transition: all 0.15s; font-family: inherit; border-radius: 10px; }
        .btn:active { transform: scale(0.95); opacity: 0.85; }
        .scroll { overflow-y: auto; -webkit-overflow-scrolling: touch; }
        .scroll::-webkit-scrollbar { width: 2px; }
        .scroll::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 1px; }
        .slide { animation: si 0.2s ease; }
        @keyframes si { from { opacity:0; transform:translateY(-5px) } to { opacity:1; transform:translateY(0) } }
        .pulse { animation: pulse 1.5s infinite; }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.5} }
      `}</style>

      {/* HEADER */}
      <div style={{ padding: "16px 16px 0", flexShrink: 0, position: "relative", overflow: "hidden" }}>
        <div style={{
          position: "absolute", inset: 0,
          background: `radial-gradient(ellipse at 60% 0%, ${person.color}15 0%, transparent 65%)`,
          transition: "background 0.5s", pointerEvents: "none",
        }} />

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
          <div>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 24, fontWeight: 700, lineHeight: 1 }}>
              SlipperJoy
            </div>
            <div style={{ fontSize: 9, color: "rgba(240,236,228,0.35)", letterSpacing: 2, marginTop: 2 }}>
              DROPSHIPPING · SHOPIFY
            </div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 9, color: "rgba(240,236,228,0.35)", letterSpacing: 1, marginBottom: 2 }}>ЗАГАЛЬНІ ВИТРАТИ</div>
            <div style={{ fontSize: 20, fontWeight: 700 }}>
              {total.toLocaleString("uk-UA", { minimumFractionDigits: 2 })} ₴
            </div>
            {totalUSD && (
              <div style={{ fontSize: 11, color: "rgba(240,236,228,0.4)" }}>≈ ${totalUSD}</div>
            )}
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6, marginBottom: 10 }}>
          {PARTNERS.map(p => (
            <div key={p.id} className="g btn" onClick={() => setAP(p.id)} style={{
              padding: "10px 6px", textAlign: "center",
              borderColor: activePerson === p.id ? p.color + "66" : undefined,
              background: activePerson === p.id ? p.color + "12" : undefined,
            }}>
              <div style={{ fontSize: 18, marginBottom: 2 }}>{p.emoji}</div>
              <div style={{ fontSize: 10, fontWeight: 700, color: activePerson === p.id ? p.color : "rgba(240,236,228,0.5)", marginBottom: 4 }}>{p.name}</div>
              <div style={{ fontSize: 13, fontWeight: 700, color: p.color }}>
                {spentFor(p.id).toLocaleString("uk-UA", { minimumFractionDigits: 0 })} ₴
              </div>
              <div style={{ fontSize: 9, color: "rgba(240,236,228,0.3)", marginTop: 1 }}>
                {(total > 0 ? (spentFor(p.id) / total * 100) : 0).toFixed(0)}%
              </div>
            </div>
          ))}
        </div>

        <div style={{ display: "flex", gap: 4, background: "rgba(255,255,255,0.03)", borderRadius: 10, padding: 3, marginBottom: 0 }}>
          {[["add","➕ Запис"],["history","📋 Історія"],["settle","⚖️ Борги"],["stats","📊 Звіт"]].map(([id, label]) => (
            <button key={id} className="btn" onClick={() => setTab(id)} style={{
              flex: 1, padding: "8px 2px", fontSize: 10, fontWeight: 600,
              background: tab === id ? person.color : "transparent",
              color: tab === id ? "#0a0a0f" : "rgba(240,236,228,0.4)",
            }}>{label}</button>
          ))}
        </div>
      </div>

      <div className="scroll" style={{ flex: 1, padding: "12px 16px 24px" }}>

        {/* ── ADD ── */}
        {tab === "add" && (
          <div className="slide">
            <div className="g" style={{ padding: 16 }}>
              <div style={{ fontSize: 11, color: "rgba(240,236,228,0.4)", marginBottom: 12, fontWeight: 600 }}>
                {person.emoji} <span style={{ color: person.color }}>{person.name}</span> витратила
              </div>

              <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
                {["UAH", "USD"].map(c => (
                  <button key={c} className="btn" onClick={() => setCurrency(c)} style={{
                    flex: 1, padding: "8px",
                    background: currency === c ? person.color : "rgba(255,255,255,0.05)",
                    color: currency === c ? "#0a0a0f" : "rgba(240,236,228,0.5)",
                    fontWeight: 700, fontSize: 13,
                    border: currency !== c ? "1px solid rgba(255,255,255,0.07)" : "none",
                  }}>{c === "UAH" ? "₴ Гривня" : "$ Долар"}</button>
                ))}
              </div>

              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 9, color: "rgba(240,236,228,0.35)", marginBottom: 5, letterSpacing: 1 }}>СУМА ({currency})</div>
                <input type="number" placeholder="0.00" value={amount}
                  onChange={e => setAmount(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && add()}
                  style={{
                    width: "100%", padding: "12px 14px", borderRadius: 10,
                    background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.09)",
                    color: "#f0ece4", fontSize: 22, fontWeight: 700,
                  }}
                />
                {amount && (
                  <div style={{ fontSize: 10, color: "rgba(240,236,228,0.3)", marginTop: 4 }}>
                    Частка кожного: {(toUAH(parseFloat(amount)||0, currency) / 3).toFixed(2)} ₴
                  </div>
                )}
              </div>

              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 9, color: "rgba(240,236,228,0.35)", marginBottom: 5, letterSpacing: 1 }}>ЗА ЩО</div>
                <input type="text" placeholder="напр. Shopify Basic план…" value={desc}
                  onChange={e => setDesc(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && add()}
                  style={{
                    width: "100%", padding: "10px 14px", borderRadius: 10,
                    background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.09)",
                    color: "#f0ece4", fontSize: 14,
                  }}
                />
              </div>

              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 9, color: "rgba(240,236,228,0.35)", marginBottom: 6, letterSpacing: 1 }}>КАТЕГОРІЯ</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                  {CATS.map(c => (
                    <button key={c.label} className="btn" onClick={() => setCat(c)} style={{
                      padding: "5px 10px", borderRadius: 16, fontSize: 10, fontWeight: 600,
                      background: cat.label === c.label ? person.color : "rgba(255,255,255,0.05)",
                      color: cat.label === c.label ? "#0a0a0f" : "rgba(240,236,228,0.5)",
                      border: cat.label !== c.label ? "1px solid rgba(255,255,255,0.07)" : "none",
                    }}>{c.icon} {c.label}</button>
                  ))}
                </div>
              </div>

              <button className="btn" onClick={add} style={{
                width: "100%", padding: "13px", fontWeight: 700, fontSize: 14,
                background: sending ? "rgba(255,255,255,0.08)" : sent ? "#4ade80" : person.color,
                color: "#0a0a0f",
              }}>
                {sending ? <span className="pulse">Надсилаємо…</span> : sent ? "✓ Збережено!" : "💸 Додати витрату"}
              </button>
            </div>
          </div>
        )}

        {/* ── HISTORY ── */}
        {tab === "history" && (
          <div className="slide">
            <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 10 }}>
              {[{id:0,label:"Всі",color:"#f0ece4"}, ...PARTNERS.map(p=>({id:p.id,label:p.name,color:p.color}))].map(f => (
                <button key={f.id} className="btn" onClick={() => setFilter(f.id)} style={{
                  padding: "5px 12px", fontSize: 10, fontWeight: 600, borderRadius: 16,
                  background: filter === f.id ? f.color : "rgba(255,255,255,0.05)",
                  color: filter === f.id ? "#0a0a0f" : "rgba(240,236,228,0.5)",
                  border: filter !== f.id ? "1px solid rgba(255,255,255,0.07)" : "none",
                }}>{f.label}</button>
              ))}
              {catFilter && (
                <button className="btn" onClick={() => setCatFilter(null)} style={{
                  padding: "5px 12px", fontSize: 10, fontWeight: 600, borderRadius: 16,
                  background: "rgba(255,100,100,0.15)", color: "rgba(255,100,100,0.8)",
                  border: "1px solid rgba(255,100,100,0.2)",
                }}>✕ {catFilter}</button>
              )}
            </div>

            {loading ? (
              <div style={{ textAlign: "center", color: "rgba(240,236,228,0.3)", padding: "30px 0" }} className="pulse">Завантаження…</div>
            ) : filtered.length === 0 ? (
              <div style={{ textAlign: "center", color: "rgba(240,236,228,0.25)", padding: "30px 0", fontSize: 13 }}>Записів немає</div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {[...filtered].reverse().map((r, idx) => {
                  const p = PARTNERS.find(x => x.name === r["Партнер"]);
                  const isSettle = r["Тип"] === "Розрахунок";
                  const isEditing = editId === (r.ID || idx);
                  return (
                    <div key={r.ID || idx} className="g slide" style={{
                      padding: "10px 12px",
                      borderLeft: `3px solid ${isSettle ? "#4ade80" : (p?.color || "#fff")}`,
                    }}>
                      {isEditing ? (
                        <div>
                          <input value={editAmount} onChange={e => setEditAmount(e.target.value)}
                            placeholder="Нова сума" type="number"
                            style={{
                              width: "100%", padding: "8px 10px", borderRadius: 8, marginBottom: 6,
                              background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.1)",
                              color: "#f0ece4", fontSize: 14,
                            }}
                          />
                          <input value={editDesc} onChange={e => setEditDesc(e.target.value)}
                            placeholder="Новий опис"
                            style={{
                              width: "100%", padding: "8px 10px", borderRadius: 8, marginBottom: 8,
                              background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.1)",
                              color: "#f0ece4", fontSize: 14,
                            }}
                          />
                          <div style={{ display: "flex", gap: 6 }}>
                            <button className="btn" onClick={() => saveEdit(r)} style={{
                              flex: 1, padding: "8px", background: "#4ade80", color: "#0a0a0f", fontWeight: 700, fontSize: 12,
                            }}>✓ Зберегти</button>
                            <button className="btn" onClick={() => setEditId(null)} style={{
                              flex: 1, padding: "8px", background: "rgba(255,255,255,0.07)", color: "rgba(240,236,228,0.6)", fontSize: 12,
                            }}>Скасувати</button>
                          </div>
                        </div>
                      ) : (
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div style={{ fontSize: 18 }}>{r["Категорія"]?.split(" ")[0]}</div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {r["Опис"]}
                              {r.edited && <span style={{ fontSize: 9, color: "rgba(240,236,228,0.3)", marginLeft: 4 }}>✏️</span>}
                            </div>
                            <div style={{ fontSize: 9, color: "rgba(240,236,228,0.35)", marginTop: 2 }}>
                              {p?.emoji} {p?.name} · {r["Категорія"]?.split(" ").slice(1).join(" ")} · {r["Дата"]}
                            </div>
                            {!isSettle && (
                              <div style={{ fontSize: 9, color: "rgba(240,236,228,0.25)", marginTop: 1 }}>
                                Частка: {(Number(r["Сума"]) / 3).toFixed(2)} ₴
                              </div>
                            )}
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <div style={{ fontWeight: 700, fontSize: 13, color: isSettle ? "#4ade80" : (p?.color || "#fff") }}>
                              {isSettle ? "✅ " : ""}{Number(r["Сума"]).toLocaleString("uk-UA", { minimumFractionDigits: 2 })} ₴
                            </div>
                            {!isSettle && (
                              <button className="btn" onClick={() => {
                                setEditId(r.ID || idx);
                                setEditAmount(String(r["Сума"]));
                                setEditDesc(r["Опис"]);
                              }} style={{
                                background: "none", color: "rgba(240,236,228,0.3)", fontSize: 11, padding: "2px 4px", marginTop: 2,
                              }}>✏️</button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
            <button className="btn" onClick={fetchRecords} style={{
              marginTop: 12, width: "100%", padding: "10px",
              border: "1px solid rgba(255,255,255,0.1)", background: "rgba(255,255,255,0.04)",
              color: "rgba(240,236,228,0.5)", fontSize: 12,
            }}>🔄 Оновити</button>
          </div>
        )}

        {/* ── SETTLE ── */}
        {tab === "settle" && (
          <div className="slide">
            <div className="g" style={{ padding: 16, marginBottom: 10 }}>
              <div style={{ fontSize: 9, color: "rgba(240,236,228,0.35)", letterSpacing: 1.5, marginBottom: 12 }}>ВИТРАТИ ПО ПАРТНЕРАХ</div>
              {PARTNERS.map(p => (
                <div key={p.id} style={{ marginBottom: 10 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                    <span style={{ fontSize: 12, fontWeight: 600 }}>{p.emoji} {p.name}</span>
                    <span style={{ fontSize: 12, fontWeight: 700, color: p.color }}>
                      {spentFor(p.id).toLocaleString("uk-UA", { minimumFractionDigits: 2 })} ₴
                    </span>
                  </div>
                  <div style={{ height: 3, background: "rgba(255,255,255,0.06)", borderRadius: 2 }}>
                    <div style={{
                      height: "100%", borderRadius: 2, background: p.color,
                      width: total > 0 ? `${(spentFor(p.id) / total * 100)}%` : "0%",
                      transition: "width 0.5s ease",
                    }} />
                  </div>
                </div>
              ))}
              <div style={{ borderTop: "1px solid rgba(255,255,255,0.07)", paddingTop: 10, marginTop: 4, display: "flex", justifyContent: "space-between" }}>
                <span style={{ fontSize: 11, color: "rgba(240,236,228,0.4)" }}>Рівна частка</span>
                <span style={{ fontSize: 11, fontWeight: 700 }}>{(total / 3).toFixed(2)} ₴</span>
              </div>
            </div>

            <div className="g" style={{ padding: 16, marginBottom: 10 }}>
              <div style={{ fontSize: 9, color: "rgba(240,236,228,0.35)", letterSpacing: 1.5, marginBottom: 12 }}>ХТО КОМУ ПОВЕРТАЄ</div>
              {debts.length === 0 ? (
                <div style={{ textAlign: "center", color: "#4ade80", padding: "16px 0", fontSize: 13, fontWeight: 600 }}>
                  ✅ Всі в розрахунку!
                </div>
              ) : debts.map((d, i) => {
                const from = PARTNERS.find(p => p.id === d.from);
                const to   = PARTNERS.find(p => p.id === d.to);
                return (
                  <div key={i} style={{
                    display: "flex", alignItems: "center", gap: 8, marginBottom: 8,
                    padding: "11px 12px", borderRadius: 10, background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.05)",
                  }}>
                    <span style={{ fontSize: 16 }}>{from.emoji}</span>
                    <div style={{ flex: 1 }}>
                      <span style={{ fontWeight: 700, color: from.color, fontSize: 12 }}>{from.name}</span>
                      <span style={{ color: "rgba(240,236,228,0.3)", fontSize: 11 }}> → </span>
                      <span style={{ fontWeight: 700, color: to.color, fontSize: 12 }}>{to.name}</span>
                    </div>
                    <div style={{
                      padding: "4px 10px", borderRadius: 6, fontSize: 13, fontWeight: 800,
                      background: "rgba(250,204,21,0.1)", border: "1px solid rgba(250,204,21,0.25)",
                      color: "#facc15",
                    }}>
                      {d.amount.toFixed(2)} ₴
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Кнопка Розрахувались */}
            {debts.length > 0 && (
              <div>
                {!settleConfirm ? (
                  <button className="btn" onClick={() => setSettleConfirm(true)} style={{
                    width: "100%", padding: "14px", fontWeight: 700, fontSize: 14,
                    background: "rgba(74,222,128,0.15)", color: "#4ade80",
                    border: "1px solid rgba(74,222,128,0.3)",
                  }}>
                    ✅ Розрахувались
                  </button>
                ) : (
                  <div className="g" style={{ padding: 14 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12, textAlign: "center" }}>
                      Підтвердити що всі борги повернуті?
                    </div>
                    {debts.map((d, i) => {
                      const from = PARTNERS.find(p => p.id === d.from);
                      const to   = PARTNERS.find(p => p.id === d.to);
                      return (
                        <div key={i} style={{ fontSize: 12, color: "rgba(240,236,228,0.6)", marginBottom: 6, textAlign: "center" }}>
                          {from.emoji} {from.name} → {to.emoji} {to.name}: <strong style={{ color: "#4ade80" }}>{d.amount.toFixed(2)} ₴</strong>
                        </div>
                      );
                    })}
                    <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                      <button className="btn" onClick={handleSettle} style={{
                        flex: 1, padding: "12px", fontWeight: 700, fontSize: 13,
                        background: settling ? "rgba(255,255,255,0.08)" : "#4ade80",
                        color: "#0a0a0f",
                      }}>
                        {settling ? <span className="pulse">Зберігаємо…</span> : "✓ Так, розрахувались!"}
                      </button>
                      <button className="btn" onClick={() => setSettleConfirm(false)} style={{
                        flex: 1, padding: "12px", fontSize: 13,
                        background: "rgba(255,255,255,0.05)", color: "rgba(240,236,228,0.5)",
                        border: "1px solid rgba(255,255,255,0.07)",
                      }}>Скасувати</button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* ── STATS ── */}
        {tab === "stats" && (
          <div className="slide">
            <div style={{ fontSize: 9, color: "rgba(240,236,228,0.35)", letterSpacing: 1.5, marginBottom: 10 }}>
              НАТИСНИ НА КАТЕГОРІЮ ЩОБ ФІЛЬТРУВАТИ
            </div>
            {catStats.length === 0 ? (
              <div style={{ textAlign: "center", color: "rgba(240,236,228,0.25)", padding: "30px 0", fontSize: 13 }}>Ще немає витрат</div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
                {catStats.sort((a, b) => b.total - a.total).map(c => (
                  <div key={c.label} className="g btn" onClick={() => {
                    setCatFilter(catFilter === c.label ? null : c.label);
                    setTab("history");
                  }} style={{ padding: "12px 14px", display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ fontSize: 20 }}>{c.icon}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>{c.label}</div>
                      <div style={{ height: 3, background: "rgba(255,255,255,0.06)", borderRadius: 2 }}>
                        <div style={{
                          height: "100%", borderRadius: 2,
                          background: `linear-gradient(90deg, ${person.color}, ${person.color}88)`,
                          width: total > 0 ? `${(c.total / total * 100)}%` : "0%",
                        }} />
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: person.color }}>
                        {c.total.toLocaleString("uk-UA", { minimumFractionDigits: 2 })} ₴
                      </div>
                      <div style={{ fontSize: 9, color: "rgba(240,236,228,0.3)" }}>
                        {total > 0 ? (c.total / total * 100).toFixed(0) : 0}%
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="g" style={{ padding: 14, marginTop: 12 }}>
              <div style={{ fontSize: 9, color: "rgba(240,236,228,0.35)", letterSpacing: 1.5, marginBottom: 10 }}>ЗАГАЛЬНИЙ ПІДСУМОК</div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span style={{ fontSize: 12, color: "rgba(240,236,228,0.5)" }}>Всього записів</span>
                <span style={{ fontSize: 12, fontWeight: 700 }}>{records.length}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span style={{ fontSize: 12, color: "rgba(240,236,228,0.5)" }}>Загальна сума</span>
                <span style={{ fontSize: 12, fontWeight: 700 }}>{total.toFixed(2)} ₴</span>
              </div>
              {totalUSD && (
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span style={{ fontSize: 12, color: "rgba(240,236,228,0.5)" }}>У доларах</span>
                  <span style={{ fontSize: 12, fontWeight: 700, color: "#4ade80" }}>${totalUSD}</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
